module.exports = __webpack_public_path__ + "static/media/AkkuratPro-Regular.49efe204.woff";